/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import EnvelopesRegularAi from './envelopes-regular-ai-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EnvelopesRegularAi {...validProps} />;
}
SvgComponent.iconName = 'envelopesRegularAi';

export const EnvelopesRegularAiIcon = svgIconWrapper(SvgComponent);
